import FormContainer from "./FormContainer.js";
import FormEvent from "./FormEvent.js";
import FormItem from "./FormItem.js";
import FormList from "./FormList.js";
import { AntdCom, useForm, useFormInstance } from "./utils.js";
export * from "./utils.js";
const observer = (FormCom)=>{
    AntdCom.form = FormCom;
};
const src_FormEvent = Object.assign(FormEvent, {
    Container: FormContainer,
    Item: FormItem,
    List: FormList,
    observer,
    useForm: useForm,
    useFormInstance: useFormInstance
});
const src = src_FormEvent;
export { src as default };
